import React, { Component } from 'react';
import { connect } from 'react-redux';
import Icon from '../../UI/Icon';

// Legacy breadcrumb bar driven by the `breadcrumbs` Redux state (account, cart,
// info and blog pages). Rendered with the shared .v-crumbs styling.
class BreadCrumbs extends Component {

    render() {
        const { navigation = [], sidebar = [], showSidebar } = this.props.breadcrumbs;
        return (
            <div className="v-legacy-crumbs">
                <div className="container">
                    <nav className="v-crumbs" aria-label="Breadcrumb">
                        <ol>
                            {navigation.map((nav, nIndex) => {
                                const last = nIndex === navigation.length - 1;
                                return (
                                    <li key={nIndex} className="text-capitalize">
                                        {last
                                            ? <span aria-current="page">{nav.name}</span>
                                            : <a href={nav.link}>{nav.name}</a>}
                                        {!last ? <Icon name="chevronRight" size={14} className="v-crumbs__sep" /> : null}
                                    </li>
                                );
                            })}
                        </ol>
                    </nav>
                    {showSidebar && sidebar.length ? (
                        <ul className="v-legacy-crumbs__side">
                            {sidebar.map((item, iIndex) => (
                                <li key={iIndex}>
                                    <a className="text-capitalize" href={item.link}>{item.name}</a>
                                </li>
                            ))}
                        </ul>
                    ) : null}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (currentState) => {
    return {
        breadcrumbs : currentState.breadcrumbs
    };
};

const mapActionsToProps = () => {
    return {};
}

export default connect(mapStateToProps, mapActionsToProps)(BreadCrumbs);
